import { render } from "./TermosPoliticas.vue?vue&type=template&id=a64a53a4"
import script from "./TermosPoliticas.vue?vue&type=script&lang=js"
export * from "./TermosPoliticas.vue?vue&type=script&lang=js"

import "./TermosPoliticas.vue?vue&type=style&index=0&id=a64a53a4&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__